import env from '@jwp/ott-common/src/env';

export const $sanityFetch = async <T>(query: string): Promise<T> => {
  const response = await fetch(
    `https://${env.APP_SANITY_PROJECT_ID}.api.sanity.io/${env.APP_SANITY_API_VERSION}/data/query/${
      env.APP_SANITY_DATASET
    }?perspective=published&query=${encodeURIComponent(query)}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const json: { result: T } = await response.json();
  return json.result as T;
};
